import { entries, groupBy, sortBy } from 'lodash';
import type { GroupedOptionsType } from '../../common-ui/form-fields/Dropdown';
import type { VehicleType } from '../graphql/fragments/gql/VehicleType';
import { type DropdownOption, transformVehicleType } from './optionTransformers';

export const getVehicleTypesGroupedByUseNoOfDrivers = (
  vehicleTypes: VehicleType[],
): Array<[string, VehicleType[]]> =>
  entries(groupBy(vehicleTypes, vt => (vt.useNoOfDrivers ? 'Accompanied' : 'Unaccompanied')));

export const getGroupedVehicleTypeOptionsByNoOfDrivers = (
  vehicleTypes: VehicleType[],
): GroupedOptionsType<DropdownOption<VehicleType>> => {
  return sortBy(
    getVehicleTypesGroupedByUseNoOfDrivers(vehicleTypes).map(([label, vehicleTypes]) => ({
      label,
      value: '',
      options: sortBy(vehicleTypes.map(transformVehicleType), ['label']),
    })),
    ['label'],
  );
};
